import { axiosInstance } from '../../utils';
import { ContentDraft } from '../../@types';

interface Payload {
  url: string;
  audioId: string;
  avatarId: string;
  videoName: string;
  draftId?: string;
}

export const createContentFromUrl = async (payload: Payload): Promise<ContentDraft> => {
  const res = await axiosInstance.post('/api/videos/scrape-url', payload);
  return res.data;
};
